import { render, staticRenderFns } from "./BindingSamplePage.vue?vue&type=template&id=2e0d3afa&scoped=true&"
import script from "./BindingSamplePage.vue?vue&type=script&lang=js&"
export * from "./BindingSamplePage.vue?vue&type=script&lang=js&"
import style0 from "./BindingSamplePage.vue?vue&type=style&index=0&id=2e0d3afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0d3afa",
  null
  
)

export default component.exports